import React, {useEffect, useState} from 'react'
import ReactNetflixPlayer from "../../other/Player-github/player-github"
import styled from 'styled-components'
import {useParams,useHistory} from "react-router-dom";
import {optimizeName} from "../../other/vod-series-name-optimizer"
import {useSelector} from "react-redux"
import DB from "../../other/local-db"
import {generateUrl} from "../../other/generate-url"

const Container = styled.div`
position:absolute;
width: 100%;
height: 100%;
top: 0;
left: 0;
`

const PlayerVod = () => {
    const {category,stream_id} = useParams();
    const history = useHistory();

    const playlist = useSelector(state => state.playlist) || [];
    const stream = playlist.find(x => (x.stream_id || x.id || x.series_id)?.toString() === stream_id?.toString());
    const [streamStat,setStreamStat] = useState(DB.findOne("movie",stream_id));

    const [url, setUrl] = useState();

    useEffect(()=>{
        if(!stream){
            console.log("PlayerVod: Stream not found, redirecting...");
            if (stream_id) {
                setUrl(generateUrl("movie", stream_id, "mp4"));
            } else {
                history.replace(`/movie/`);
            }
            return;
        }

        let rawUrl = stream.direct_source || generateUrl("movie", stream.stream_id || stream.id, stream.container_extension || "mp4");
        setUrl(rawUrl);
    },[stream, stream_id])

    useEffect(()=>{
        let stat = DB.findOne("movie",stream_id);
        !stat && (stat={id: stream_id, start:0, tot:0}) 
        setStreamStat(stat)
        DB.set("movie",stream_id, stat)
    },[category, stream_id])

    const setStat = (stat) =>{
        setStreamStat(stat);
        DB.set("movie",stream_id, stat)
    }


    if (!stream) return null;

    return (
        <Container>
            <ReactNetflixPlayer
            src={url}
            title={optimizeName(stream?.name || "")}
            titleMedia={optimizeName(stream?.name || "")}
            backButton={()=> history.goBack()}
            FullPlayer
            autoPlay
            startPosition={streamStat ? parseInt(streamStat.start) : 0}
            syncDuration = {(duration, percentage) => setStat({...streamStat, start:duration, tot : parseInt(percentage)})}

            OnEnded={()=> {DB.del("movie",stream_id);history.goBack()}}
            overlayEnabled
            autoControllCloseEnabled
            Style
            primaryColor="var(--second-color)"
            secundaryColor="var(--first-color)"
            />
        </Container>
    )
}

export default PlayerVod
